import { Link } from 'react-router-dom';
import { Trash2 } from 'lucide-react';

function DemolitionSitePreparation() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/demolition_site_prep_collage.jpg)' }}
        ></div>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Demolition & Site <span className="text-gold">Preparation</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Professional demolition, site clearing, and preparation services
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              Professional demolition and site preparation services are critical first steps for any construction project. Williams Diversified provides comprehensive demolition services with an emphasis on safety, environmental responsibility, and efficiency.
            </p>
            <p>
              From selective interior demolition to complete structural teardown, we have the equipment, expertise, and experience to handle projects of any size. Our site preparation services ensure your property is ready for new construction.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Services Include</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Structural demolition</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Interior strip-outs</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Debris removal and hauling</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Land clearing and grading</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Environmental remediation</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Site utilities preparation</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Ready to <span className="text-gold">Get Started?</span></h3>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default DemolitionSitePreparation;